import { ROLES } from '@/models/Rolle';
import GebaeudeAuswertungView from '@/views/auth/auswertungen/gebaeude/IndexView.vue';
import ProduktionAuswertungView from '@/views/auth/auswertungen/produktion/IndexView.vue';

export default [
    {
        path: '/auswertungen/gebaeude',
        name: 'aus_geb',
        component: GebaeudeAuswertungView,
        meta: {
            requiresAuth: true,
            roles: [ROLES.auswertungen],
        },
    },
    {
        path: '/auswertungen/produktion',
        name: 'aus_prod',
        component: ProduktionAuswertungView,
        meta: {
            requiresAuth: true,
            roles: [ROLES.auswertungen],
        },
    },
];

